import { Component, OnInit } from '@angular/core';
import { TRANSFER_SURVIVOR_PENSION_BENEFICIARIES_URI } from '@constants';
import { environment } from '@env';
import { HomeTransferContent, HomeTransferSection } from '@interfaces/homeContent.interface';
import { GoogleAnalyticsProvider } from '@providers/googleAnalytics/googleAnalytics';
import { ModalProvider } from '@providers/modal/modal';
import { CmsService } from '@services/cms/cms.service';
import { Util } from '@util';

@Component({
  selector: 'app-unassisted',
  templateUrl: './unassisted.component.html',
  styleUrls: ['./unassisted.component.scss']
})
export class UnassistedComponent implements OnInit {
  public loading = false;
  public content: HomeTransferContent;
  public cards: HomeTransferSection[];
  public leftCards: HomeTransferSection[];

  public get isMobile(): boolean { return this.util.isTablet; }
  public get publicSiteURL(): string { return `${environment.publicSiteUrl}${this.content.sections[3].redirectTo}`; }


  constructor(
    private googleAnalyticsProvider: GoogleAnalyticsProvider,
    private modalProvider: ModalProvider,
    public util: Util,
    private cmsService: CmsService,
  ) {
    this.googleAnalyticsProvider.registerPageView('unassisted');
  }

  public ngOnInit() {
    this.loadScript();
    this.loadContent();
  }

  private loadContent(): void {
    this.loading = true;
    this.cmsService.loadHomeContent().toPromise().then( response => {
      this.content = response;
      this.cards = this.content.sections.slice(0, 2);
      this.leftCards = this.content.sections.slice(2);
    }).finally(() => this.loading = false);
  }

  public openAuthorizedPhonesModal() {
    this.modalProvider.openAuthorizedPhonesModal();
  }

  public redirectToPublicSite() {
    window.open(`${environment.publicSiteUrl}${this.content.sections[3].redirectTo}`, '_blank');
  }

  /**
   * Carga script de campaña de Adnexus
   */
  private loadScript() {
    const script = document.createElement('script');
    script.src = 'https://secure.adnxs.com/seg?add=35468041&t=1';
    script.type = 'text/javascript';
    document.body.appendChild(script);
  }
}
